import { useEffect, useState } from "react";

export const useSetSearchKeyword = (query: URLSearchParams) => {
  const [searchedKeyword, setSearchedKeyword] = useState("");

  useEffect(() => {
    const initialQuery = query.get("s");
    if (initialQuery) {
      setSearchedKeyword(initialQuery);
    }
  }, [setSearchedKeyword, query]);

  return { searchedKeyword, setSearchedKeyword };
};
